export default __webpack_public_path__ + "static/media/Rep male.f6eaf464.jpg";